/* eslint-disable @typescript-eslint/no-explicit-any */
// Custom Error that allows for more structured error handling in Tafkan
// Any additional context is passed to HB when reporting errors
export default class TafkanError extends Error {
    constructor({ name, message, cause, context, }) {
        super(message);
        this.name = name;
        this.message = message;
        this.cause = cause;
        this.context = context;
    }
}
